import { defineNuxtPlugin } from '#app';

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.directive('observe', {
    mounted(el, binding) {
      const callback = binding.value;
      let hasEnteredOnce = false; // Traccia se l'elemento è già entrato

      const observer = new IntersectionObserver(
        (entries, observerInstance) => {
          entries.forEach(entry => {
            const isInView = entry.isIntersecting;

            // Caso: Entrata
            if (isInView) {
              entry.target.classList.add('is-inview');

              // Invoca la callback solo se è specificato "enterOnce" e non è già stata chiamata
              if (binding.modifiers.enterOnce && !hasEnteredOnce) {
                hasEnteredOnce = true; // Imposta che l'elemento è già entrato
                if (typeof callback === 'function') {
                  callback({ entry, inView: true });
                }
                observerInstance.unobserve(entry.target); // Smetti di osservare
                return;
              }

              // Invoca la callback per "enter" o "default" comportamento
              if (
                typeof callback === 'function' &&
                (!binding.modifiers.exit || binding.modifiers.enter)
              ) {
                callback({ entry, inView: true });
              }
            } else {
              // Caso: Uscita
              entry.target.classList.remove('is-inview');

              // Invoca la callback solo per "exit"
              if (binding.modifiers.exit && typeof callback === 'function') {
                callback({ entry, inView: false });
              }
            }
          });
        },
        {
          rootMargin: '0px 0px -1% 0px',
          threshold: 0,
        }
      );

      // Avvia l'osservazione
      observer.observe(el);
      el._observer = observer;
    },
    unmounted(el) {
      // Disconnetti l'observer quando l'elemento è rimosso
      if (el._observer) {
        el._observer.disconnect();
        delete el._observer;
      }
    },
  });
});
